import { z } from 'zod'
import type { SysMessage } from '@/enums/sys-message'

import {
  commonGetMarqueeSchema,
  type CommonGetMarquee
} from '@/models/api/common-get-marquee'
import {
  commonGetSysMessageSchema,
  type CommonGetSysMessage
} from '@/models/api/common-get-sys-message'
import type { SaveIpErrorRecordRequest } from '@/models/api/save-ip-error-record-request'
import {
  areaCountryStationSchema,
  type AreaCountryStation,
  stationListDataSchema,
  type StationListData
} from '~library/models'
import {
  apiValidator,
  type ApiFactory,
  type ApiRequestConfig,
  type ApiResponse
} from '~library/services'

export default class CommonUnAuthApi {
  constructor(private api: ApiFactory) {}

  /**
   * API 取得區域、國家與場站對應清單
   * https://hackmd.io/TZcN6jygS9WaOEKFl-UOdA
   */
  @apiValidator(areaCountryStationSchema.array())
  getAreaCountryStation(): Promise<ApiResponse<AreaCountryStation[]>> {
    return this.api.get('Common/GetAreaCountryStation')
  }

  /**
   * API 取得場站清單
   * https://hackmd.io/atyPnEomRkOKUIeD2er7Zw
   */
  @apiValidator(stationListDataSchema.array())
  getStation(): Promise<ApiResponse<StationListData[]>> {
    return this.api.get('Common/GetStation')
  }

  /**
   * API 取得跑馬燈資訊
   * https://hackmd.io/ZSO5oWUST4S0wKc57d2Xlg
   */
  @apiValidator(commonGetMarqueeSchema.array())
  getMarquee(
    config?: ApiRequestConfig
  ): Promise<ApiResponse<CommonGetMarquee[]>> {
    return this.api.get('Common/GetMarquee', config)
  }

  /**
   * API 取得系統訊息
   * https://hackmd.io/rdVml3UkTx-LBOBpaNmICw
   */
  @apiValidator(commonGetSysMessageSchema.nullable())
  getSysMessage(
    type: SysMessage,
    config?: ApiRequestConfig
  ): Promise<ApiResponse<CommonGetSysMessage | null>> {
    return this.api.get(`Common/GetSysMessage/${type}`, config)
  }

  /**
   * API 檢查站台狀態
   * https://hackmd.io/qHsbi9JNQaCmv9QPzUipnA
   */
  getCheckPlatformStatus(): Promise<ApiResponse> {
    return this.api.get('Common/CheckPlatformStatus', {
      timeout: 20000,
      headers: {
        disableAlert: true
      }
    })
  }

  /**
   * API 記錄驗證碼與IP錯誤多次
   * https://hackmd.io/PJMO5VCNRrC97_hhxWTD1Q
   */
  @apiValidator(z.null())
  saveIpErrorRecord(
    data: SaveIpErrorRecordRequest
  ): Promise<ApiResponse<null>> {
    return this.api.post('Common/SaveIpErrorRecord', data)
  }

  /**
   * FAQ檔案下載
   * https://hackmd.io/JEtwRQLlSFeAcDp9Jygu_g
   */
  downloadFaqFile(fileId: string): Promise<void> {
    return this.api.downloadFile({
      method: 'GET',
      url: `Common/GetFaqFile/${fileId}`
    })
  }
}
